import React from "react";
import { List } from "../../components/List";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { GenericListProps } from "../../types/GenericListType";
import { ProcessSteps, ProcessStepsProps } from "../../components/ProcessSteps";
import { LinkButton, LinkButtonProps } from "../../components/LinkButton";
import { Links, LinksProps } from "../../components/Links";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { PricingTable, PricingTableProps } from "../../components/PricingTable";
import { GroupedComponents } from "../../components/GroupedComponents";
import { Responsibilities, ResponsibilitiesProps } from "../../components/Responsibilities";

export interface NewSimpleGasConnectionPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  lists?: GenericListProps[];
  responsibilities?: ResponsibilitiesProps[];
  processes?: ProcessStepsProps[];
  applyButton?: LinkButtonProps;
  linksList?: LinksProps[];
  faqs?: FaqAccordionGroupProps;
  tables?: PricingTableProps[];
}

export const NewSimpleGasConnectionPage: React.FC<NewSimpleGasConnectionPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  lists,
  responsibilities,
  processes,
  applyButton,
  linksList,
  faqs,
  tables,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      <GroupedComponents>
        {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
        {lists && lists[0] && <List {...lists[0]} />}
        {paragraphs && paragraphs[1] && <Paragraph {...paragraphs[1]} />}
        {tables && tables[0] && <PricingTable {...tables[0]} />}
        {tables && tables[1] && <PricingTable {...tables[1]} />}
      </GroupedComponents>
      {lists && lists[1] && <List {...lists[1]} />}
      {responsibilities && responsibilities[0] && <Responsibilities {...responsibilities[0]} />}
      {processes && processes[0] && <ProcessSteps {...processes[0]} />}
      {lists && lists[2] && <List {...lists[2]} />}
      {lists && lists[3] && <List {...lists[3]} />}
      {applyButton && <LinkButton {...applyButton} />}
      {linksList && linksList[0] && <Links {...linksList[0]} />}
    </ServiceCataloguePageWrapper>
  );
};
